import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';
import { canEnterTransfers } from '@/store/transferAccess';

// Gates the transfer views on any BU rank or global admin. The backend is the
// real boundary; this just keeps the UI honest.
const TransfersRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  if (!canEnterTransfers(authorization)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need a role in a business unit to view transfers."
      />
    );
  }
  return <>{children}</>;
};

export default TransfersRoute;
